import 'regenerator-runtime/runtime';
import { call, put, fork, takeEvery } from 'redux-saga/effects';
import { parseError } from 'logic/helpers';
import * as constants from '../constants';
import * as actions from '../actions';
import api from '../api';

function* checkUsername(req) {
  try {
    const { username } = req.payload;
    const response = yield call(api.checkUsername.bind(null, username));
    yield put(actions.loginSetUserType({ ...response, username }));
  } catch (e) {
    // yield put(actions.loginSetUserType(response));
    yield put(actions.postLoginFailure(parseError(e)));
  }
}

function* authTokenRequest(req) {
  try {
    yield call(api.postAuthToken.bind(null, req.payload));
    yield [put(actions.fetchUserSelfRequest()), put(actions.authTokenSent())];
  } catch (e) {
    yield put(actions.authTokenFailure());
  }
}

export default [
  fork(takeEvery, constants.LOGIN_CHECK_USERNAME_REQUEST, checkUsername),
  fork(takeEvery, constants.POST_AUTH_TOKEN_REQUEST, authTokenRequest),
];
